/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type TransferCallBackofficeMutationVariables = {};
export type TransferCallBackofficeMutationResponse = {
    readonly transferCallBackoffice: {
        readonly result: string;
    } | null;
};
export type TransferCallBackofficeMutation = {
    readonly response: TransferCallBackofficeMutationResponse;
    readonly variables: TransferCallBackofficeMutationVariables;
};



/*
mutation TransferCallBackofficeMutation {
  transferCallBackoffice {
    result
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TransferCallBackoffice",
    "kind": "LinkedField",
    "name": "transferCallBackoffice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TransferCallBackofficeMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TransferCallBackofficeMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "fa4119e43a9d422586f2a8ef34b3dc53",
    "id": null,
    "metadata": {},
    "name": "TransferCallBackofficeMutation",
    "operationKind": "mutation",
    "text": "mutation TransferCallBackofficeMutation {\n  transferCallBackoffice {\n    result\n  }\n}\n"
  }
};
})();
(node as any).hash = '215e09691ec458b35317ff8b042121e6';
export default node;
